export default __webpack_public_path__ + "static/media/GelBoxFullBufferOpen.d94c310b.svg";